import { NavLink } from 'react-router-dom'
import { usePermission } from '@/lib/permissions'
import { AUDIT_CENTER_READ_PERMISSIONS } from '@/lib/auditCenter'
import { cn } from '@/lib/utils'

/**
 * "Audit" in the header line (z8nrz7dq6q, spec 2026-09-22: "to be accessible
 * from the header line so from anywhere we can access it"). Rendered by the
 * TopBar and by the /dashboard header, which hides the TopBar.
 *
 * Shown only to someone who can read an audit trail — the spec's "access to be
 * controlled by role": audit.read, or any one trail's audit.<trail>.read. The
 * route and the endpoint enforce the same keys.
 */
export function AuditCenterLink() {
  const { canAny } = usePermission()
  if (!canAny(AUDIT_CENTER_READ_PERMISSIONS)) return null
  return (
    <NavLink
      to='/audit'
      title='Audit Trail Center — search every audit trail'
      // Bold and always underlined, as the spec's header mockup draws it — it
      // reads as the way in to the Center, not as a label. On the Center
      // itself it takes the primary colour.
      className={({ isActive }) =>
        cn(
          'shrink-0 rounded-md px-2 py-1 text-[15px] font-bold text-foreground underline decoration-2 underline-offset-4 transition-colors hover:bg-muted',
          isActive && 'text-primary',
        )
      }
    >
      Audit
    </NavLink>
  )
}
